/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class UtmSettings extends Fragment {
  @attr('boolean') enabled;
  @attr('string') utmCampaign;
}
